<agpr-scroll-panel
    [id]="'contentLibrarySelectedFiles_scrollPanel'"
    class="agpr-mutipleItemSelection-scrollPanel"
>
    <div
        id="contentLibrarySelectedFiles"
        class="agpr-mutipleItemSelection"
    >
        <div
            id="contentLibrarySelectedFiles_header"
            class="agpr-mutipleItemSelection-header"
        >
            <span id="contentLibrarySelectedFiles_count">
                {{ 'Common.contentLibrary.files.selected' | localize: { count:
                currentlySelectedItems.length } }}
            </span>
            <agpr-button
                [id]="'contentLibrarySelectedFiles_clear'"
                class="agpr-mutipleItemSelection-header-clear"
                icon="fa-regular fa-duotone fa-xmark"
                [agprTooltip]="'Common.contentLibrary.files.selected.clear' | localize"
                tooltipPosition="left"
                (click)="clearSelection()"
            ></agpr-button>
        </div>

        <div
            id="contentLibrarySelectedFiles_list"
            class="agpr-mutipleItemSelection-list"
        >
            @for (item of currentlySelectedItems; track item.id; let i = $index) {
                <div
                    [id]="'contentLibrarySelectedFiles_media_' + i"
                    class="agpr-mutipleItemSelection-list-media"
                >
                    <agpr-content-library-item
                        [id]="'contentLibrarySelectedFiles_item_' + i"
                        class="agpr-mutipleItemSelection-list-media-item"
                        [item]="item"
                        [showRemoveButton]="true"
                        [showCheckbox]="false"
                        (clearSelectionRequested)="removeItem(item)"
                    ></agpr-content-library-item>
                </div>
            }
        </div>
    </div>
</agpr-scroll-panel>
